import { byId } from '../dom.ts';
import { notify, state, subscribe } from '../state.ts';
import { composite, previewDims } from '../compositor.ts';

/** Preview canvas: always-running rAF draw of composite(), plus wipe dragging. */
export function initPreview(): void {
  const canvas = byId<HTMLCanvasElement>('preview');
  const ctx = canvas.getContext('2d', { alpha: false })!;

  function draw(): void {
    // Re-queue FIRST so a draw error can never kill the preview loop.
    requestAnimationFrame(draw);
    if (window.__aka) window.__aka.drawCount = (window.__aka.drawCount ?? 0) + 1;
    const dims = previewDims();
    if (canvas.width !== dims.w || canvas.height !== dims.h) {
      canvas.width = dims.w;
      canvas.height = dims.h;
    }
    composite(ctx, canvas.width, canvas.height, true);
  }
  requestAnimationFrame(draw);

  // Wipe divider dragging — anywhere on the canvas while in wipe layout.
  let dragging = false;

  function setWipeFromEvent(e: PointerEvent): void {
    const rect = canvas.getBoundingClientRect();
    if (!rect.width) return;
    state.wipe = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
    notify();
  }

  canvas.addEventListener('pointerdown', (e) => {
    if (state.layout !== 'wipe') return;
    dragging = true;
    canvas.setPointerCapture(e.pointerId);
    setWipeFromEvent(e);
  });
  canvas.addEventListener('pointermove', (e) => {
    if (dragging) setWipeFromEvent(e);
  });
  const endDrag = (e: PointerEvent): void => {
    if (!dragging) return;
    dragging = false;
    canvas.releasePointerCapture(e.pointerId);
  };
  canvas.addEventListener('pointerup', endDrag);
  canvas.addEventListener('pointercancel', endDrag);

  subscribe(() => {
    canvas.classList.toggle('wipe-cursor', state.layout === 'wipe');
    byId('drop-hint').style.display = state.clips.length ? 'none' : '';
  });
}
